import { createApp } from 'vue'
import App from './App.vue'
 
import './assets/app.css'
import router from './router'
import PrimeVue from 'primevue/config'; 

import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import InputText from 'primevue/inputtext';
import Avatar from 'primevue/avatar'; 
import Menu from 'primevue/menu';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import PanelMenu from 'primevue/panelmenu';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';

import Chart from 'primevue/chart';

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dropdown from 'primevue/dropdown';
import Listbox from 'primevue/listbox';
import Dialog from 'primevue/dialog';

import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

import Card from 'primevue/card';
import Button from 'primevue/button';
import TabMenu from 'primevue/tabmenu';
import Badge from 'primevue/badge';
import Tag from 'primevue/tag';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Slider from 'primevue/slider';
import Checkbox from 'primevue/checkbox';
import Panel from 'primevue/panel';
import Textarea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import Paginator from 'primevue/paginator';
import Menubar from 'primevue/menubar';
import Toolbar from 'primevue/toolbar';
import ContextMenu from 'primevue/contextmenu';
import Sidebar from 'primevue/sidebar';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import SelectButton from 'primevue/selectbutton';
import StyleClass from 'primevue/styleclass';
import FileUpload from 'primevue/fileupload';
import Message from 'primevue/message';
import Divider from 'primevue/divider';


import Calendar from 'primevue/calendar';


import { initTheme } from './theme';
initTheme();

 
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas)

const app = createApp(App);
app.config.productionTip = false;
app.config.devtools = true;
app.component('font-awesome-icon', FontAwesomeIcon);

app.component('InputText', InputText);
app.component('Avatar', Avatar);
app.component('Menu', Menu);
app.directive('tooltip', Tooltip);
app.component('ToggleButton', ToggleButton);
app.component('PanelMenu', PanelMenu);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('Row', Row);
app.component('Chart', Chart);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Dropdown', Dropdown);
app.component('Card', Card);
app.component('Button', Button);
app.component('TabMenu', TabMenu);
app.component('Listbox', Listbox);
app.component('Dialog', Dialog);
app.component('Badge', Badge);
app.component('Tag', Tag);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('Slider', Slider);
app.component('Checkbox', Checkbox);
app.component('Panel', Panel);
app.component('Textarea', Textarea);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('Paginator', Paginator);
app.component('Menubar', Menubar);
app.component('Toolbar', Toolbar);
app.component('ContextMenu', ContextMenu);
app.component('Sidebar', Sidebar);
app.component('ConfirmDialog', ConfirmDialog);
app.component('SelectButton', SelectButton);
app.directive('styleclass', StyleClass);
app.component('FileUpload', FileUpload);
app.component('Calendar', Calendar);
app.component('Message', Message);
app.component('Divider', Divider);


app.component('Toast', Toast); // Registrar el componente Toast globalmente
app.use(ToastService); // Usar el servicio de Toast

app.use(ConfirmationService);
app.use(router);
app.use(PrimeVue, {
    locale: {
        dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    }
});


app.mount('#app');
